import {useEffect, useState} from 'react';

import {REQUESTS_DISPLAY_FILES_URL} from 'components/request/constants/requests.constants';
import {fetchPermissionDisplayFileComponent} from 'modules/data/data-api';

interface IUseDisplayFilePermissionArgs {
  requestTypeId: number | undefined;
}

/**
 * Хук `useDisplayFilePermission` проверяет наличие разрешения на отображение компонента файлов
 * для указанного типа запроса.
 *
 * @param {IUseDisplayFilePermissionArgs} args - Аргументы с идентификатором типа запроса.
 * @returns {boolean} Возвращает `true`, если разрешение на отображение компонента есть, иначе `false`.
 */
export const useDisplayFilePermission = ({requestTypeId}: IUseDisplayFilePermissionArgs) => {
    const [hasPermissionDisplayFileComponent, setPermissionDisplayFileComponent] = useState(false);

    useEffect(() => {
        try {
            const checkPermissionDisplayFileComponent = async () => {
                const hasPermissionDisplay = await fetchPermissionDisplayFileComponent(
                    REQUESTS_DISPLAY_FILES_URL,
                    requestTypeId,
                );

                setPermissionDisplayFileComponent(hasPermissionDisplay?.data);
            };
            checkPermissionDisplayFileComponent();
        } catch (e) {
            console.error('Ошибка при отображении компонента файла: ', e);
        }
    }, [requestTypeId]);

    return hasPermissionDisplayFileComponent;
};
